class Utils {

    // event_day : datestring : "Thu Apr 07 2022 15:00:00 GMT-0500"
    countdown_checker(event_day) {

        let event = new Date(event_day);
        let today = new Date();
        let difference = event - today

        //setHours(Math.floor((difference / 1000) / 60 / 60))
        //setMinutes(Math.floor((difference / 1000) / 60) % 60)
        //setSeconds(Math.floor((difference / 1000) % 60))

        return today.getTime() >= event.getTime()

        //return { "hours": hours, "minutes": minutes, "seconds": seconds }
    }

    countdown(event_day) {

        let event = new Date(event_day);
        let today = new Date();
        let difference = event - today

        let hours, minutes, seconds

        hours = Math.floor((difference / 1000) / 60 / 60)
        minutes = Math.floor((difference / 1000) / 60) % 60
        seconds = Math.floor((difference / 1000) % 60)

        return { "hours": hours, "minutes": minutes, "seconds": seconds }
    }
}

export default new Utils();